import { Link } from 'react-router-dom'
import { deskHref } from './links'
import { PAGE_HELP } from './manual'

/** The small "How this works" link in a Desk page's header: opens that page's part of the manual. */
export function HelpLink({ page }: { page: keyof typeof PAGE_HELP }) {
  return (
    <Link
      to={deskHref('help', PAGE_HELP[page])}
      className="text-[13px] text-amber-glow underline underline-offset-2 hover:text-paper focus:outline-none focus-visible:ring-2 focus-visible:ring-amber-glow"
    >
      How this works
    </Link>
  )
}
